import axiosInstance from './axiosConfig';

export interface AdminUser {
    email: string;
    fullName: string;
}

/**
 * Get list of all admin users
 */
export async function listAdmins(): Promise<AdminUser[]> {
    try {
        const response = await axiosInstance.get('/user/admins');
        if (response.data?.status === 'SUCCESS' && response.data?.resultObject) {
            return response.data.resultObject;
        }
        return [];
    } catch (error) {
        console.error('Error fetching admins:', error);
        throw error;
    }
}

/**
 * Add admin role to a user
 * @param email - User email to add as admin
 */
export async function addAdminRole(email: string) {
    try {
        const response = await axiosInstance.post(`/user/addAdminRole/${email}`);
        return {
            success: response.data?.status === 'SUCCESS',
            data: response.data,
        };
    } catch (error) {
        console.error('Error adding admin role:', error);
        return {
            success: false,
            error,
        };
    }
}

/**
 * Remove admin role from a user
 * @param email - User email to remove admin role from
 */
export async function removeAdminRole(email: string) {
    try {
        const response = await axiosInstance.delete(`/user/removeAdmin/${email}`);
        return {
            success: response.data?.status === 'SUCCESS',
            data: response.data,
        };
    } catch (error) {
        console.error('Error removing admin role:', error);
        return {
            success: false,
            error,
        };
    }
}
